export default __webpack_public_path__ + "static/media/test_end_all_background.82372df7.jpg";